import React, { useState } from 'react';
import { useStore } from '../../contexts/StoreContext';
import { ChangeLog } from '../../types/admin';
import { formatDateTime } from '../../utils/format';
const types: {
  id: ChangeLog['entityType'] | '';
  label: string;
}[] = [{
  id: '',
  label: 'Todo'
}, {
  id: 'vehiculo',
  label: 'Unidades'
}, {
  id: 'marca',
  label: 'Marcas'
}, {
  id: 'banner',
  label: 'Banners'
}, {
  id: 'ajustes',
  label: 'Ajustes'
}];
export function HistoryPanel() {
  const {
    changes
  } = useStore();
  const [type, setType] = useState<ChangeLog['entityType'] | ''>('');
  const list = changes.filter(c => !type || c.entityType === type).slice(0, 300);
  return <div data-id="element-102" data-mp="38uzpzavj09n9">
      <div className="flex flex-wrap gap-2" role="tablist" aria-label="Filtrar historial" data-id="element-103" data-mp="34rjsydfjo7a1">
        {types.map(t => <button key={t.id} role="tab" aria-selected={type === t.id} onClick={() => setType(t.id)} className={`rounded-lg border px-3 py-1.5 text-sm ${type === t.id ? 'border-neon bg-neon/10' : 'border-line text-mist hover:text-white'}`} data-id="element-104" data-mp="3iqt777k6wrbd">
            {t.label}
          </button>)}
      </div>
      {list.length === 0 ? <p className="mt-6 rounded-2xl border border-dashed border-line p-10 text-center text-sm text-mist" data-id="element-105" data-mp="3m1bxffrwcgon">
          Sin modificaciones registradas. Cada cambio de precio, condición o contenido quedará asentado acá con su fecha.
        </p> : <div className="mt-5 overflow-x-auto rounded-2xl border border-line" data-id="element-106" data-mp="3vgvkgwlk0wd">
          <table className="w-full min-w-[720px] text-sm" data-id="element-107" data-mp="3tcnrnvkuhqt">
            <thead className="bg-panel text-left text-xs text-mist" data-id="element-108" data-mp="8sz1dyfbi005">
              <tr data-id="element-109" data-mp="dkqkjnw593g9">
                <th className="p-3 font-medium" data-id="element-110" data-mp="dmbf3digkme4">Fecha</th>
                <th className="p-3 font-medium" data-id="element-111" data-mp="ijtr5crrvhqc">Elemento</th>
                <th className="p-3 font-medium" data-id="element-112" data-mp="ija79qikaj9o">Campo</th>
                <th className="p-3 font-medium" data-id="element-113" data-mp="mmgasqeahwcg">Antes</th>
                <th className="p-3 font-medium" data-id="element-114" data-mp="mju4eu34xmvt">Después</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-line" data-id="element-115" data-mp="riou8fzisbpf">
              {list.map(c => <tr key={c.id} data-id="element-116" data-mp="2no65yffv1efo">
                  <td className="whitespace-nowrap p-3 text-xs text-mist" data-id="element-117" data-mp="2jmktuwb5h46j">{formatDateTime(c.at)}</td>
                  <td className="p-3" data-id="element-118" data-mp="2xdfwhqv22p1o">{c.entityLabel}</td>
                  <td className="p-3 font-mono text-xs text-mist" data-id="element-119" data-mp="2xf0phc1q1zxf">{c.field}</td>
                  <td className="max-w-[200px] truncate p-3 text-mist" title={c.from} data-id="element-120" data-mp="2sm7motptd1nz">{c.from}</td>
                  <td className="max-w-[200px] truncate p-3" title={c.to} data-id="element-121" data-mp="37aki9pkzoihy">{c.to}</td>
                </tr>)}
            </tbody>
          </table>
        </div>}
    </div>;
}